var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('rc-widget-live-results-body',{attrs:{"page_basename":"senate","page_name":"Senate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }